export const enum BuyerType {
    Individual = 0,
    Company = 1,
}